import english from '../public/locales/en/messages';
import japanese from '../public/locales/ja/messages';
import korean from '../public/locales/ko/messages';
import chinese from '../public/locales/zh-cn/messages';
import chineseTradional from '../public/locales/zh-tw/messages';

class I18n {
    constructor() {
        switch(navigator.language) {
            case 'ja':
                this.translations = japanese;
                break;
            case 'ko':
                this.translations = korean;
                break;
            case 'zh-CN':
                this.translations = chinese;
                break;
            case 'zh-TW':
                this.translations = chineseTradional;
                break;
            case 'en':
            default:
                this.translations = english;
        }
    }

    translate(key) {
        return this.translations[key].message;
    }

    translateWithPlaceholder(key, placeholders){
        let currentTranslation = this.translations[key].message;
        Object.keys(placeholders).forEach((placeholderKey) => {
            currentTranslation = currentTranslation.replace(`\$${placeholderKey}\$`, placeholders[placeholderKey]);
        });
        return currentTranslation;
    }
}

export default new I18n();
